// extracted by mini-css-extract-plugin
module.exports = {"regions":"styles_regions__204QJ","favorite":"styles_favorite__1VHMi","info":"styles_info__1rgaR"};